var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:('width:'+_vm.size)},[(_vm.hasImage())?_c('b-img-lazy',{attrs:{"src":_vm.makeAvImg(),"size":_vm.size,"fluid":"","rounded":"circle","variant":_vm.makeAvVariant()}}):_c('b-avatar',{attrs:{"text":_vm.makeAvText(),"size":_vm.size,"variant":_vm.makeAvVariant()}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }